import ApplicationController from "./application_controller";
import intlTelInput from "intl-tel-input";
import { inline_edit } from "../utils/inline_edit";

/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */

  static targets = ["result", "loadingIcon", "buttonText"];

  static values = {
    currentApp: String,
    recordId: String,
    urlSolution: String,
    filtertype: String,
  };

  connect() {
    console.log("contacts_recrutements JS en cours ...");
    super.connect();
    window.initIntTelSimple = this.initIntTel;
    window.inline_edit = inline_edit;
 
    if ($.fn.editable) {
        inline_edit()
      } else {
        console.error("x-editable non chargé : $.fn.editable est undefined")
      }

    /* 
        this.element.addEventListener('stimulus-reflex:after', event => {
            if (event.detail.reflex === 'ContactsRecrutementsReflex#update_file') {
              console.log('JS déclenché après Reflex avec event.detail.reflex !',event.detail.reflex);
              let section_cvs = $("#section_cvs");
              let section_desciption = $("#section_desciption");

              section_cvs.removeClass("fx-d-none");
              section_cvs.addClass("w-40");

              section_desciption.removeClass("w-100");
              section_desciption.addClass("w-60");
            }
            if (event.detail.reflex === 'ContactsRecrutementsReflex#delete_file') {
                console.log('JS déclenché après Reflex avec event.detail.reflex !',event.detail.reflex);
                let section_cvs = $("#section_cvs");
                let section_desciption = $("#section_desciption");
  
                section_cvs.addClass("fx-d-none");
                section_cvs.removeClass("w-40");
  
                section_desciption.removeClass("w-60");
                section_desciption.addClass("w-100");
              }
          });*/

    if (
      $("#partial-missions-content").length &&
      $("#partial-missions-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_missions(), 300);
    }

    if (
      $("#partial-primes-content").length &&
      $("#partial-primes-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_primes(), 300);
    }

    if (
      $("#partial-paies-content").length &&
      $("#partial-paies-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_paies(), 300);
    }

    if (
      $("#partial-campagne_destinataires-content").length &&
      $("#partial-campagne_destinataires-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_campagne_destinataires(), 300);
    }

    if (
      $("#partial-collab_acomptes-content").length &&
      $("#partial-collab_acomptes-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_collab_acomptes(), 300);
    }

    if (
      $("#partial-entretiens_rhs-content").length &&
      $("#partial-entretiens_rhs-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_entretiens_rhs(), 300);
    }

    if (
      $("#partial-arrets_maladies-content").length &&
      $("#partial-arrets_maladies-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_arrets_maladies(), 300);
    }

    if (
      $("#partial-visites_medicales-content").length &&
      $("#partial-visites_medicales-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_visites_medicales(), 300);
    }

    if (
      $("#partial-justificatifs-content").length &&
      $("#partial-justificatifs-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_justificatifs(), 300);
    }

    if (
      $("#partial-st_commandes-content").length &&
      $("#partial-st_commandes-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_st_commandes(), 300);
    }

    if (
      $("#partial-diplomes-content").length &&
      $("#partial-diplomes-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_diplomes(), 300);
    }

    if (
      $("#partial-formations-content").length &&
      $("#partial-formations-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_formations(), 300);
    }

    if (
      $("#partial-certifications-content").length &&
      $("#partial-certifications-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_certifications(), 300);
    }

    if (
      $("#partial-declarations_competences-content").length &&
      $("#partial-declarations_competences-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(
        () => this.contacts_recrutement_declarations_competences(),
        300
      );
    }

    if (
      $("#partial-materiels-content").length &&
      $("#partial-materiels-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_materiels(), 300);
    }

    if (
      $("#partial-documents-content").length &&
      $("#partial-documents-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_documents(), 300);
    }

    if (
      $("#partial-entretiens_candidats-content").length &&
      $("#partial-entretiens_candidats-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_entretiens_candidats(), 300);
    }

    if (
      $("#partial-collab_cv-content").length &&
      $("#partial-collab_cv-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_collab_cv(), 300);
    }

    if (
      $("#partial-references-content").length &&
      $("#partial-references-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_references(), 300);
    }

    if (
      $("#partial-historique_employe-content").length &&
      $("#partial-historique_employe-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_historique_employe(), 300);
    }

    if (
      $("#partial-propositions-content").length &&
      $("#partial-propositions-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_propositions(), 300);
    }

    if (
      $("#partial-interlocuteurs-content").length &&
      $("#partial-interlocuteurs-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_recrutement_interlocuteurs(), 300);
    }

    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });
      $("#filterrific_with_entreprise_raison_sociale").on("input", function () {
        $("#target_entreprise_raison_sociale").val(
          $("#filterrific_with_entreprise_raison_sociale").val()
        );
      });
      var targetElement = document.getElementById("mySidebar");
      targetElement.addEventListener("scroll", (event) => {
        var element = document.getElementById("mySidebar");
        console.log(
          "From contacts_recrutement_controller.js =======> ",
          element.scrollTop
        );
        document.getElementById("scrollevel").value = element.scrollTop;
      });
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const bonsDeCommandeParam = url.searchParams.get("previous_record");

      if (bonsDeCommandeParam != null) {
        var trElement = $("#contacts_recrutement_" + bonsDeCommandeParam);
        $("#contacts_recrutement_" + bonsDeCommandeParam + " td").addClass(
          "highlighted-td"
        );
        $("#contacts_recrutement_" + bonsDeCommandeParam)
          .get(0)
          .scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }

  contacts_recrutement_missions() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_missions?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-missions-content").html("");
          $("#partial-missions-content").html(text);
          $("#partial-missions-badge").html(
            "(" +
              $(".show_ajax_for_hm_missions >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_historique_employe(event = null) {
    let order = event ? event.target.value : null; // Récupérer order seulement si event existe
    if (event) {
      if (event.type === "change") {
        order = event.target.value;
      } else if (event.type === "click") {
        event.preventDefault();
        order = event.currentTarget.dataset.contactsEmployeSort;
      }
    }

    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_historique_employe?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";

      if (order) {
        url += "&" + this.filtertype + "=" + encodeURIComponent(order);
      }

      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-historique_employe-content").html("");
          $("#partial-historique_employe-content").html(text);
          $("#partial-historique_employe-badge").html(
            "(" +
              $(".show_ajax_for_hm_employes >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_propositions() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_propositions?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-propositions-content").html("");
          $("#partial-propositions-content").html(text);
          $("#partial-propositions-badge").html(
            "(" +
              $(".show_ajax_for_hm_propositions >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_interlocuteurs() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_contact_interlocuteurs?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-interlocuteurs-content").html("");
          $("#partial-interlocuteurs-content").html(text);
          $("#partial-interlocuteurs-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_contact_interlocuteurs >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_paies_pagination(event = null) {
    let order = event ? event.target.value : null; // Récupérer order seulement si event existe
    if (event) {
      if (event.type === "change") {
        order = event.target.value; // Pour le select
      } else if (event.type === "click") {
        event.preventDefault();
        order = event.currentTarget.dataset.contactsEmployeSort;
      }
    }
    console.log("Tri sélectionné :", order);
    console.log("Tri sélectionné :", event);

    console.log("currentAppValue:", this.currentAppValue);
    console.log("recordIdValue:", this.recordIdValue);
    console.log("filter type est ", this.filtertype);

    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_paies?contacts_recrutement_id=" +
        this.recordIdValue;

      if (order) {
        url += "&order=" + encodeURIComponent(order);
      }

      url += "&vr2=1";

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          $("#partial-paies-content").html(text);
          $("#partial-paies-badge").html(
            "(" +
              $(".show_ajax_for_hm_paies >tbody >tr:not(.no_record)").length +
              ")"
          );
        })
        .catch((error) =>
          console.error("Erreur lors du chargement des paies :", error)
        );
    } else {
      console.error("Erreur : currentAppValue ou recordIdValue est manquant !");
    }
  }

  contacts_recrutement_paies() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_paies?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-paies-content").html("");
          $("#partial-paies-content").html(text);
          $("#partial-paies-badge").html(
            "(" +
              $(".show_ajax_for_hm_paies >tbody >tr:not(.no_record)").length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_campagne_destinataires() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_campagne_destinataires?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-campagne_destinataires-content").html("");
          $("#partial-campagne_destinataires-content").html(text);
          $("#partial-campagne_destinataires-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_campagne_destinataires >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_employe_materiels() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_employe_materiels?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-employe_materiels-content").html("");
          $("#partial-employe_materiels-content").html(text);
          $("#partial-employe_materiels-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_employe_materiels >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_participations_interventions() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_participations_interventions?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-participations_interventions-content").html("");
          $("#partial-participations_interventions-content").html(text);
          $("#partial-participations_interventions-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_participations_interventions >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_primes() {
    console.log("contacts_recrutement_primes");
    console.log(this.currentAppValue);
    console.log(this.recordIdValue);
    console.log(this.url_solution);

    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_primes?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-primes-content").html("");
          $("#partial-primes-content").html(text);
          $("#partial-primes-badge").html(
            "(" +
              $(".show_ajax_for_hm_primes >tbody >tr:not(.no_record)").length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_collab_acomptes() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_collab_acomptes?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-collab_acomptes-content").html("");
          $("#partial-collab_acomptes-content").html(text);
          $("#partial-collab_acomptes-badge").html(
            "(" +
              $(".show_ajax_for_hm_collab_acomptes >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_entretiens_rhs() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_entretiens_rhs?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-entretiens_rhs-content").html("");
          $("#partial-entretiens_rhs-content").html(text);
          $("#partial-entretiens_rhs-badge").html(
            "(" +
              $(".show_ajax_for_hm_entretiens_rhs >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_arrets_maladies() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_arrets_maladies?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-arrets_maladies-content").html("");
          $("#partial-arrets_maladies-content").html(text);
          $("#partial-arrets_maladies-badge").html(
            "(" +
              $(".show_ajax_for_hm_arrets_maladies >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_visites_medicales() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_visites_medicales?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-visites_medicales-content").html("");
          $("#partial-visites_medicales-content").html(text);
          $("#partial-visites_medicales-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_visites_medicales >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_justificatifs() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_justificatifs?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-justificatifs-content").html("");
          $("#partial-justificatifs-content").html(text);
          $("#partial-justificatifs-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_transport_justificatifs >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_st_commandes() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_st_commandes?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-st_commandes-content").html("");
          $("#partial-st_commandes-content").html(text);
          $("#partial-st_commandes-badge").html(
            "(" +
              $(".show_ajax_for_hm_commandes_st >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_diplomes() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_diplomes?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-diplomes-content").html("");
          $("#partial-diplomes-content").html(text);
          $("#partial-diplomes-badge").html(
            "(" +
              $(".show_ajax_for_hm_diplomes >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_formations() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_formations?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-formations-content").html("");
          $("#partial-formations-content").html(text);
          $("#partial-formations-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_employe_formations_formations >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_certifications() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_certifications?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-certifications-content").html("");
          $("#partial-certifications-content").html(text);
          $("#partial-certifications-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_employe_formations_certifications >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_declarations_competences() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_declarations_competences?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-declarations_competences-content").html("");
          $("#partial-declarations_competences-content").html(text);
          $("#partial-declarations_competences-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_evaluations_competences >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_materiels() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_employe_materiels?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-materiels-content").html("");
          $("#partial-materiels-content").html(text);
          $("#partial-materiels-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_employe_materiels >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_documents(event = null) {
    let order = event ? event.target.value : null; // Récupérer order seulement si event existe
    if (event) {
      if (event.type === "change") {
        order = event.target.value; // Pour le select
      } else if (event.type === "click") {
        event.preventDefault();
        order = event.currentTarget.dataset.contactsEmployeSort; // Pour le clic sur un TH
      }
    }

    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_documents?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";

      if (order) {
        url += "&" + this.filtertype + "=" + encodeURIComponent(order); // Ajouter le tri seulement s'il est défini
      }
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-documents-content").html("");
          $("#partial-documents-content").html(text);
          $("#partial-documents-badge").html(
            "(" +
              $(".show_ajax_for_hm_documents >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_entretiens_candidats() {
    console.log("contacts_recrutement_entretiens_candidats");
    console.log(this);
    console.log(this.recordIdValue);
    console.log(this.urlSolutionValue);
    console.log("contacts_recrutement_entretiens_candidats");
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_entretiens_candidats?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";

      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-entretiens_candidats-content").html("");
          $("#partial-entretiens_candidats-content").html(text);
          $("#partial-entretiens_candidats-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_entretiens_candidats >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_collab_cv() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_collab_cv?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-collab_cv-content").html("");
          $("#partial-collab_cv-content").html(text);
          $("#partial-collab_cv-badge").html(
            "(" +
              $(".show_ajax_for_hm_contact_cvs >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_recrutement_references() {
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_recrutements/show_ajax_for_hm_references?contacts_recrutement_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-references-content").html("");
          $("#partial-references-content").html(text);
          $("#partial-references-badge").html(
            "(" +
              $(".show_ajax_for_hm_references >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  async submit(event) {
    event.preventDefault();

    this.buttonTextTarget.style.display = "none";
    this.loadingIconTarget.style.display = "inline-block";

    const form = event.target;
    const formData = new FormData(form);
    const queryString = new URLSearchParams(formData).toString();

    try {
      const response = await fetch(`${form.action}?${queryString}`, {
        method: form.method,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      if (response.ok) {
        const html = await response.text();
        this.resultTarget.innerHTML = html;
      } else {
        console.error("Erreur lors de la requête AJAX !");
      }
    } catch (error) {
      console.error("Erreur de connexion :", error);
    }

    this.buttonTextTarget.style.display = "inline";
    this.loadingIconTarget.style.display = "none";
  }

  replaceWithInitials(event) {
    const img = event.target;

    // Vérifier si l'élément est bien une image
    if (!(img instanceof HTMLImageElement)) {
      console.error("L'élément cible n'est pas une image", img);
      return;
    }

    // Récupérer les initiales depuis l'attribut data
    const initials = img.dataset.initials || "?";

    // Créer une div pour afficher les initiales
    const div = document.createElement("div");
    div.className = "avatar-initials";
    div.textContent = initials;
    div.title = img.alt; // Ajoute un tooltip

    // Remplacer l'image par la div
    img.replaceWith(div);
  }


}
